// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__1Hj21","footer":"ModalUpdate_footer__1clh1"};